<template>
  <el-row style="min-height: 100vh; background-color: #c6dcec">
    <el-col :span="24" class="form-out-block">
      <el-col :span="20" class="form-inner-block">
        <!-- 标题 -->
        <div class="form-title">
          <span>{{ title }}</span>
        </div>
        <!-- 副标题 -->
        <div class="form-remark">
          <div v-html="remark"></div>
        </div>
        <!-- 分割线 -->
        <div class="separation-line"></div>
        <div class="form-block">
          <v-form-render
            :form-json="formJson"
            :form-data="formData"
            :option-data="optionData"
            ref="vFormRef"
          >
          </v-form-render>
        </div>
        <div  v-if="this.imgUrl" >
          <!--          <el-image   :src="imgserver + imgUrl" fit="fill"></el-image>-->
          <el-image   style="height: 100%; width: 100%"
                      :src="imgserver + this.imgUrl" fit="cover" ></el-image>
        </div>
        <div class="form-button">
          <el-button
            type="primary"
            size="medium"
            @click="submitForm"
            :disabled="submitBtnBol"
            >{{ submitBtnText }}</el-button
          >
        </div>
      </el-col>
    </el-col>
  </el-row>
</template>

<script>
import {
  saveOsFormReport,
  findOsFormTemplateInfo,
} from "@/api/customFormApi.js";
import { getBannerListApi } from "@/api/homeApi";
import { Decrypt } from "../utils/screate";
import device from "current-device";
import shareMethods from "@/common/shareMethods";

export default {
  name: "home",
  components: {},
  data() {
    return {
      bannerList: [],
      bannerHeight: 22.9,
      title: "",
      remark: "",
      imgUrl: null,
      formJson: {},
      formData: {},
      optionData: {},
      // 初始化表单对象
      formTemplate: {},
      submitBtnBol: false,
      submitBtnText: "提交表单",
      mobiePhoneShow: true,
    };
  },
  mixins: [shareMethods],
  created() {

    let imgUrl = "https://www.csysedu.com/favicon.png";
    let linkUrl = window.location.href ;
    let desc = "长沙市唯上商务科技学校";
    let title = "长沙市唯上商务科技学校";
    this.share(imgUrl, linkUrl,desc, title );

    var id = Decrypt(this.$route.query.id);
    findOsFormTemplateInfo(id).then((res) => {
      if (res.code == 200) {
        this.formTemplate = res.data;
        this.fillFormJson = JSON.parse(res.data.content);
        this.title = res.data.name;
        this.remark = this.dealRemark(res.data.remark);
        this.imgUrl = res.data.imgUrl;
        setTimeout(() => {
          this.$refs.vFormRef.setFormJson(this.fillFormJson);
        });
      }
    });

    this.handleResize();
    getBannerListApi(0).then((res) => {
      this.bannerList = res.data;
    });
  },
  methods: {
    dealRemark(content) {
      var tmpcontents = content;
      // let r = RegExp(/<[(img|iframe)]+\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
      // 获取文本中style部分
      var reg = RegExp(/<iframe\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
      var matchres = tmpcontents.match(reg);
      // 获取style部分中width部分
      var widthReg = RegExp(/\bwidth\b\:\s+(.*?)\;/g);
      // 获取style部分中height部分
      var heightReg = RegExp(/\bheight\b\:+\s+(.*?)\;/g);
      // let matchres = tmpcontents.match(r); //返回数组['<img ... />','<img ... />']
      var imglength = this.mobiePhoneShow ? "120" : "100";
      if (matchres) {
        matchres.forEach((item, index) => {
          var innnermatchres = item.match(/(style=\")+\s*(.*?)\"/g);
          innnermatchres.forEach((inneritem, index) => {
            var widthMatch = inneritem.match(widthReg);
            var heightMatch = inneritem.match(heightReg);
            if (widthMatch && heightMatch) {
              var realwidth = widthMatch[0].match(/\d+/g);
              var realheight = heightMatch[0].match(/\d+/g);
              var finalheight;
              if (realwidth && realheight) {
                finalheight =
                  (realheight[0] / realwidth[0]) * imglength + "rem";
              }
              let _str =
                'style="width:' +
                imglength +
                "rem !important;height:" +
                finalheight +
                ';text-align:center;"'; //追加之后的img
              tmpcontents = tmpcontents.replace(inneritem, _str);
            }
          });
        });
        // 获取style部分中width部分
      }
      let r = RegExp(/<img\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
      let matchresArray = tmpcontents.match(r); //返回数组['<img ... />','<img ... />']
      // 判断标签是否含有style，含有替换
      // (?<=<p\s+style=").*(?=">)
      if (matchresArray && matchresArray.length > 0) {
        matchresArray.forEach((item, index) => {
          let len = item.length;
          if (item.indexOf("style") < 0) {
            // 不含style 新增
            let _newStyleStr =
              item.slice(0, len - 2) +
              '" style="max-width: 100%  !important; width: 120rem !important;height:auto !important;text-align:center;"/>'; //追加之后的img
            tmpcontents = tmpcontents.replace(item, _newStyleStr);
          } else {
            var startStyleIndex = item.indexOf("style") + 7;
            var endStyleIndex = item.indexOf('"', startStyleIndex);
            let _styleStr =
              "width:" +
              imglength +
              "rem;max-width: 100%; height:auto !important;text-align:center;";
            // 判断标签是否含有style，含有替换
            tmpcontents = tmpcontents.replace(
              item.slice(startStyleIndex, endStyleIndex),
              _styleStr
            );
          }
        });
      }
      let tableReg = RegExp(/<table\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
      let tableMatchresArray = tmpcontents.match(tableReg); //返回数组['<img ... />','<img ... />']
      if (tableMatchresArray && tableMatchresArray.length > 0) {
        tableMatchresArray.forEach((item, index) => {
          let len = item.length;
          if (item.indexOf("style") < 0) {
            // 不含style 新增
            let _newStyleStr =
              item.slice(0, len - 2) +
              '" style="max-width: 100%  !important; width: 120rem !important;height:auto !important;text-align:center;"/>'; //追加之后的img
            tmpcontents = tmpcontents.replace(item, _newStyleStr);
          } else {
            var startStyleIndex = item.indexOf("style") + 7;
            var endStyleIndex = item.indexOf('"', startStyleIndex);
            let _styleStr =
              "width:" +
              imglength +
              "rem;max-width: 100%; height:auto !important;text-align:center;";
            // 判断标签是否含有style，含有替换
            tmpcontents = tmpcontents.replace(
              item.slice(startStyleIndex, endStyleIndex),
              _styleStr
            );
          }
        });
      }
      return tmpcontents;
    },

    handleResize() {
      var html = document.getElementsByTagName("html")[0];
      var oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      // 这里的750是指设计图的大小,自己根据实际情况改变
      html.style.fontSize = (oWidth / 1440) * 10 + "px";
      this.mobiePhoneShow = oWidth < 768 ? true : false;
      var screenWidth = window.innerWidth;
    },

    submitForm() {
      this.$refs.vFormRef
        .getFormData()
        .then((formData) => {
          // Form Validation OK
          // saveOsFormReport
          saveOsFormReport({
            formTemplate: this.formTemplate,
            content: JSON.stringify(formData),
            address: "",
            device: device.os

          }).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "提交成功!",
              });
              // 禁用提交按钮
              this.submitBtnBol = true;
              this.submitBtnText = "已提交";

              //跳转
              if(this.formTemplate.jumpUrl){
                let time = setTimeout(() => {
                  clearTimeout(time);
                  window.location.href = this.formTemplate.jumpUrl;
                }, 800)
              }

            }
            this.dialogFillVisible = false;
          });
        })
        .catch((error) => {
          // Form Validation failed
          this.$message.error(error);
        });
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.getFuncList();
    next((vm) => {});
  },
  computed: {},
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.form-out-block {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  justify-content: center;
  align-items: center;
  .form-inner-block {
    border-radius: 20px;
    margin-top: 30px;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    padding-bottom: 20px;
    justify-content: center;
    align-content: center;
    align-items: center;
    width: 800px;
    .form-title {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 30px;
      span {
        width: 600px;
        text-align: center;
        font-size: 30px;
        font-weight: 700;
        color: #050d33;
      }
    }
    .form-remark {
      padding: 0 20px;
      margin: 20px 0;
      width: 600px;
    }
    .separation-line {
      width: 100%;
      border: 1px solid #f3f3f5;
    }
    .form-block {
      width: 800px;
      box-sizing: border-box;
      padding: 0 200px;
      margin-top: 20px;

      ::v-deep .el-form-item {
        display: flex;
        flex-direction: row;
        width: 400px;
        .el-form-item__label {
          flex-shrink: 0;
          width: 180px !important;
        }
        .el-form-item__content {
          margin-left: 0px !important;
        }



      }

    }
    .form-button {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 20px;
      .el-button {
        width: 180px;
        height: 50px;
      }
    }
  }
}

.html-block {
  border: 1px solid #f1f1f1;
}
@media only screen and (max-width: 1920px) {
}

@media only screen and (max-width: 1439px) {
  .form-out-block {
    .form-inner-block {
      width: 100rem;
      .form-remark {
        width: 80rem;
        font-size: 18px;
      }
      .form-block {
        width: 100rem;
        box-sizing: border-box;
        padding: 0 10rem;
        margin-top: 20px;
      }
    }
  }
}
@media only screen and (max-width: 1330px) {
}
@media only screen and (max-width: 1200px) {
}
@media only screen and (max-width: 992px) {
  .form-out-block {
    .form-inner-block {
      .form-title {
        span {
          width: 300px;
          font-size: 22px;
        }
      }
      .form-remark {
        font-size: 16px;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .form-out-block {
    .form-inner-block {
      width: 140rem;
      .form-title {
        span {
          width: 120rem;
          font-size: 22px;
        }
      }
      .form-remark {
        width: 120rem;
        font-size: 16px;
      }
      .form-block {
        width: 140rem;
        padding-right: 0;
        padding: 0 2rem;
        ::v-deep .el-form-item {
          width: 136rem;

          display: flex;
          flex-wrap: wrap;
          align-items: center;
          .el-form-item__label {
            min-width: 80px !important;
            text-align: start;
          }
          .el-form-item__content {
            margin-left: 0px !important;
            width: 80rem;
            text-align: center;
          }
          ::v-deep .el-radio {
            margin-right: 0 !important;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 520px) {
  .form-inner-block {
    .form-title {
      span {
        font-size: 16px;
      }
    }
    .form-remark {
      font-size: 12px;
    }
  }

  .form-out-block {
    .form-inner-block {
      width: 140rem;
      .form-title {
        span {
          width: 120rem;
          font-size: 22px;
        }
      }
      .form-remark {
        width: 120rem;
        font-size: 16px;
      }
      .form-block {
        width: 140rem;
        padding-right: 0;
        padding: 0 5rem;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        ::v-deep .el-form-item {
          .el-form-item__content {
            width: 130rem;
          }
        }
      }
    }
  }
}
</style>
